import { SEARCH_RESULT_ARE_LOADING, SEARCH_RESULT_HAVE_ERROR, SEARCH_RESULT_FETCH_DATA_SUCCESS } from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function searchResult (state = initialState, action) {
    switch (action.type) {
        case SEARCH_RESULT_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case SEARCH_RESULT_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case SEARCH_RESULT_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.searchResult,
                loading:false,
            }

        default:
            return state;
    }
}
